<template>
  <jtCard
    containerHeight="429"
    title="今日运单量"
    style="margin-bottom: 30px"
  >
    <div class="container">
      <div
        class="chart"
        id="StorageContainer1"
        style="width: 100%; height: 350px"
      ></div>
      <!-- <div v-else>暂无数据</div> -->
    </div>
  </jtCard>
</template>
<script>
//先导入charts
import Charts from "@jiaminghi/charts";
import jtCard from "@/components/Card";
export default {
  components: {
    jtCard,
  },
  props: {
    tbWarehousingGoods: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    // this.$nextTick(()=>{    
    //   this.initChart()
    // })
    // setTimeout(()=>{
      this.initChart()
    // },1000)
  },
  methods: {
    initChart(){
      let xValueT = this.tbWarehousingGoods.accessData.map(x=>{
        return x.time
      })
      let sddata = this.tbWarehousingGoods.servedData.map(x=>{
        return x.count
      })
      let jqdata = this.tbWarehousingGoods.accessData.map(x=>{
        return x.count
      })
      //下面和eacharts差不多
      const container = document.getElementById("StorageContainer1");
      const myChart = new Charts(container);
      const option = {
        // title: {
        //   text: '周销售额趋势'
        // },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show:true,
          top: 40,
          left:550,
          selectAble:true,
          textStyle: {
            fill: "#5BB0FF",
            fontSize: 20,
          },
          textUnselectedStyle: {
            fontFamily: 'Arial',
            fontSize: 13,
            fill: '#2DF9CC'
          },
          data: [
            { name: "到达运单", color: "#5BB0FF"},
            { name: "接取运单", color: "#18C066" },
          ],
        },

        xAxis: {
          name: '日期',
          // data: ['6-4', '6-5', '6-6', '6-7', '6-8', '6-9', '6-10', '6-10'],
          data: xValueT,
          axisLabel: {
            style: {
              fontSize: 20,
              fill: "#fff",
            },
          },
          axisTick:{
            show: false
          }
        },
        yAxis: {
          // name: '吨',
          data: 'value',
          min:0,
          axisLine: {
            style: {
              borderType: "dashed",
            },
            show:false
          },
          splitLine:{
            show: xValueT.length<3? true: false,
          },
          axisLabel: {
            style: {
              fontSize: 20,
              fill: "#fff",
            },
          },

        },
        series: [
          {
            name: "到达运单",
            data: sddata,
            type: 'line',
            smooth: xValueT.length<3? false: true,
            lineArea: {
              show: true,
              gradient: ["RGBA(91, 176, 255, 1)", "RGBA(91, 176, 255, 0.08)"],
            },
            lineStyle: {
              stroke: "#5BB0FF",
              lineWidth: 4
            },
            linePoint: {
              // radius: 6,
              style: {
                fill: "#5BB0FF",
                stroke: "transparent",
              },
            },

          },
          {
            name: "接取运单",
            data: jqdata,
            type: 'line',
            smooth: xValueT.length<3? false: true,
            lineArea: {
              show: true,
              gradient: ["RGBA(89, 140, 215, 1)", "RGBA(89, 140, 215, 0.08)"],
            },
            lineStyle: {
              stroke: "#18C066",
              lineWidth: 4
            },
            linePoint: {
              radius: 1,
              style: {
                fill: "#18C066",
                stroke: "transparent",
              },
            },

          }
        ]
       
      };

      myChart.setOption(option);

      //图表自适应
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    }
  },
};
</script>
<style scoped>
.chart {
  height: 240px;
  margin-left: 15px;
}

h2 {
  height: 48px;
  color: white;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  line-height: 48px;
}
</style>
